import { openBlock as e, createElementBlock as t } from "vue";
/* empty css                    */
/* empty css                    */
import r from "./design-system.es128.js";
const o = { class: "ds-divider" }, i = /* @__PURE__ */ Object.assign({
  name: "DsDivider"
}, {
  __name: "Divider",
  setup(s) {
    return (c, _) => (e(), t("div", o));
  }
}), m = /* @__PURE__ */ r(i, [["__scopeId", "data-v-b082889d"]]);
export {
  m as default
};
//# sourceMappingURL=design-system.es29.js.map
